// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__g2Wf8","productName":"Table_productName__26F-s"};